import { IpawsChannel } from "src/gql/graphql";
import { match } from "ts-pattern";

export function formatIpawsChannel(ch: IpawsChannel): string {
    return match(ch)
        .with(IpawsChannel.Cmas, () => "WEA")
        .otherwise((it) => it.toString());
}
